import IIV from './IIV.class.js'

export {
  // eslint-disable-next-line import/prefer-default-export
  IIV,
}
